import React from "react";
import ReactDOM from "react-dom";
import { Router, Route, Switch,Redirect } from "react-router-dom";
import history from "./history.js";
import indexRoutes from "./routes/index.jsx";

import "./assets/scss/material-dashboard-pro-react.css?v=1.2.0";


ReactDOM.render(
  <Router history={history}>
    <Switch>
      {indexRoutes.map((prop, key) => {
        if(prop.redirect){
          return <Redirect from={prop.path} to={prop.pathTo} key={key} />
      }
          return <Route exact path={prop.path} component={prop.component} key={key} />
        
      
      })}
    </Switch>
  </Router>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js